enum CASPartner {
    DEALERTRACK = 'dealertrack',
    ROUTE_ONE = 'routeone',
}

export const partnerDisplayNames = {
    [CASPartner.DEALERTRACK]: 'Dealertrack',
    [CASPartner.ROUTE_ONE]: 'RouteOne',
}

export default CASPartner
